// packages
import { makeStyles } from '@rneui/themed';
import { PropsMain } from './index';

export default makeStyles((theme, props: PropsMain) => ({
  iconContainer: {
    alignItems: 'center',
    backgroundColor: props.dark ? theme.colors.grey0 : theme.colors.greyOutline,
    borderRadius: 8,
    height: 45,
    justifyContent: 'center',
    width: 45
  }
}));
